import React from 'react';

function CorpContact({ contacts = [], setContacts }) {
  const handleAddContact = () => {
    setContacts([
      ...contacts,
      {
        name: '',
        role: '',
        email: '',
        phone: ''
      }
    ]);
  };

  const handleRemoveContact = (index) => {
    const newContacts = contacts.filter((_, i) => i !== index);
    setContacts(newContacts);
  };

  const handleContactChange = (index, field, value) => {
    const newContacts = [...contacts];
    newContacts[index] = { ...newContacts[index], [field]: value };
    setContacts(newContacts);
  };

  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <button
          type="button"
          onClick={handleAddContact}
          style={{
            padding: '8px 16px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          + Add Contact
        </button>
      </div>

      {contacts.map((contact, index) => (
        <div
          key={index}
          style={{
            padding: '16px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            marginBottom: '12px',
            position: 'relative'
          }}
        >
          <button
            type="button"
            onClick={() => handleRemoveContact(index)}
            style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              padding: '4px 8px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Remove
          </button>

          <div>
            <label style={{ display: 'block', marginBottom: '4px' }}>Name</label>
            <input
              type="text"
              value={contact.name}
              onChange={(e) => handleContactChange(index, 'name', e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '4px' }}>Role</label>
            <input
              type="text"
              value={contact.role}
              onChange={(e) => handleContactChange(index, 'role', e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '4px' }}>Email</label>
            <input
              type="email"
              value={contact.email}
              onChange={(e) => handleContactChange(index, 'email', e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '4px' }}>Phone</label>
            <input
              type="tel"
              value={contact.phone}
              onChange={(e) => handleContactChange(index, 'phone', e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default CorpContact; 